import styled from"@emotion/styled";import WpIcon from"@wp/src/common/images/WpIcon";import{WpParagraph as DefaultParagraph}from"@wp/src/components/common/WpTopography";import{mediaQuery}from"@wp/src/components/common/grid";export const NotificationListContainer=styled.div`
  width: 340px;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
`;export const NotificationsHeading=styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${props=>props.theme.colors.neutral400};
  padding: 16px;
`;export const Paragraph=styled(DefaultParagraph)`
  ${mediaQuery({marginBottom:["0em !important"]})}
`;export const NotificationContentContainer=styled.div`
  display: flex;
  font-weight: 400;
  align-items: center;
  font-size: 14px;
  color: ${props=>props.theme.colors.neutral800};
  padding: 10px 16px;
  cursor: pointer;
  &:hover {
    background: ${props=>props.theme.colors.neutral100};
  }
`;export const NotificationTextContent=styled.div`
  max-width: 275px;
`;export const NotificationIcon=styled(WpIcon)`
  margin-right: 8px;
  background: ${props=>props.theme.colors.neutral100};
  border-radius: 15px;
  width: 24px;
  height: 24px;
`;